export default "__VITE_ASSET__ba0cbc38__"